<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>Associar ao Marketplace Mygon</ion-title>
        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding padding-horizontal">

    <div class="current-association-card" *ngIf="CurrentAssociation">
        <ion-item lines="none" color="transparent">
            <ion-label>
                <p><strong>Associação atual</strong></p>
                <h2>{{ CurrentAssociation?.Name || '--' }}</h2>
                <p>
                    <a *ngIf="CurrentAssociation?.Url" [href]="CurrentAssociation?.Url" target="_blank"
                        rel="noopener noreferrer">
                        {{ CurrentAssociation?.Url }}
                    </a>
                </p>
            </ion-label>
            <ion-button slot="end" fill="outline" color="danger" (click)="OnDisassociate()">
                Remover Associação
            </ion-button>
        </ion-item>
    </div>

    <ion-grid class="table">

        <ion-row class="table-header">
            <ion-col size="1" class="flex-align-center flex-justify-center"></ion-col>
            <ion-col size="3" class="flex-align-center">Nome</ion-col>
            <ion-col size="3" class="flex-align-center">Morada</ion-col>
            <ion-col size="5" class="flex-align-center">URL</ion-col>
        </ion-row>

        <ion-row class="table-body clickable" [class.row-selected]="SelectedItem?.IdExternal === item?.IdExternal"
            *ngFor="let item of Data" (click)="SelectItem(item)">

            <ion-col size="1" class="flex-align-center flex-justify-center">
                <ion-icon
                    [name]="SelectedItem?.IdExternal === item?.IdExternal ? 'checkmark-circle' : 'ellipse-outline'"
                    [color]="SelectedItem?.IdExternal === item?.IdExternal ? 'primary' : 'medium'">
                </ion-icon>
            </ion-col>

            <ion-col size="3" class="flex-align-center">
                {{ item?.Name || '--' }}
                <!-- <ion-badge
                    *ngIf="CurrentAssociation?.IdExternal === item?.IdExternal"
                    color="success"
                    style="margin-left: 8px;">
                    Associado
                </ion-badge> -->
            </ion-col>

            <ion-col size="3" class="flex-align-center">
                {{ (item?.Address || '--') + (item?.ZipCode ? ', ' + item?.ZipCode : '') }}
            </ion-col>

            <ion-col size="5" class="flex-align-center url-col">
                <a *ngIf="item?.Url" [href]="item?.Url" target="_blank" rel="noopener noreferrer"
                    (click)="$event.stopPropagation()">
                    {{ item?.Url }}
                </a>
                <span *ngIf="!item?.Url">--</span>
            </ion-col>

        </ion-row>

        <ion-row *ngIf="!Data?.length">
            <ion-col>
                <no-items></no-items>
            </ion-col>
        </ion-row>

    </ion-grid>

</ion-content>

<ion-footer>
    <ion-toolbar class="ion-padding">
        <ion-item lines="none">
            <ion-checkbox slot="start" [checked]="TermsAccepted" (ionChange)="TermsAccepted = $event.detail.checked">
            </ion-checkbox>
            <ion-label class="ion-text-wrap ion-padding-start">
                <div [innerHTML]="Marketplace?.Compliance?.Description"></div>
            </ion-label>
        </ion-item>
        <ion-buttons slot="end">
            <ion-button fill="solid" color="primary" [disabled]="!CanAssociate" (click)="OnAssociate()">
                Associar
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>